import React from 'react'

import './Saving.scss'
import Spinner from '../Loader/Spinner'

function Saving() {
  return (
    <div className="loader-saving">
      <Spinner />
    </div>
  )
}

export default Saving
